var _g, _mask, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 10C8.5 7.79086 10.2909 6 12.5 6H27.9965C29.2105 6 30.371 6.49937 31.2056 7.38088L41.2898 18.0318C42.0669 18.8526 42.5 19.9399 42.5 21.0701V50C42.5 52.2091 40.7091 54 38.5 54H12.5C10.2909 54 8.5 52.2091 8.5 50V30V10Z",
    fill: "#7747F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9 8.067 10.567 6.5 12.5 6.5H27.9965C29.0731 6.5 30.1023 6.94287 30.8425 7.72465L40.9268 18.3756C41.6159 19.1035 42 20.0678 42 21.0701V50C42 51.933 40.433 53.5 38.5 53.5H12.5C10.567 53.5 9 51.933 9 50V30V10Z",
    stroke: "url(#paint0_linear)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 35,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.12121C8.5 6.9497 9.4497 6 10.6212 6H28.0505C29.2681 6 30.4318 6.50239 31.2668 7.38857L41.2971 18.0334C42.0697 18.8533 42.5 19.9374 42.5 21.064V51.8788C42.5 53.0503 41.5503 54 40.3788 54H10.6212C9.4497 54 8.5 53.0503 8.5 51.8788V30V8.12121Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1994,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6894 5.67067C32.3409 5.26981 39.8133 11.0162 39.8133 11.0162C39.8133 11.0162 43.1186 16.8918 43.1186 21.0918C38.1753 20.1793 26.1489 22.4445 26.1489 22.4445C26.1489 22.4445 27.0587 11.0162 28.6894 5.67067Z",
    fill: "#050A5B"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0605 5.7404L30.1795 5.64453L37.2772 11.2611L42.5883 17.7182V21.1112L42.5164 20.6471C42.4163 20.001 41.8601 19.5244 41.2063 19.5244H31.0873C30.0622 19.5244 29.2312 18.6934 29.2312 17.6683V7.33737C29.2312 6.67619 28.7441 6.11608 28.0893 6.02441L26.0605 5.7404Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5527 48.1113C16.0801 48.1113 16.3965 47.7891 16.3965 47.2266V42.4629H16.4492L20.1172 47.6016C20.3867 47.9766 20.6211 48.1113 21.002 48.1113C21.5586 48.1113 21.8691 47.8008 21.8691 47.25V40.3184C21.8691 39.75 21.5586 39.4277 21.0254 39.4277C20.4922 39.4277 20.1758 39.75 20.1758 40.3184V45.0527H20.1289L16.4727 39.9434C16.2031 39.5742 15.957 39.4277 15.5938 39.4277C15.0312 39.4277 14.7031 39.75 14.7031 40.3125V47.2266C14.7031 47.7891 15.0195 48.1113 15.5527 48.1113ZM24.226 48.1113C24.7827 48.1113 25.1108 47.7715 25.1108 47.1914V44.6719H27.894C28.3569 44.6719 28.6498 44.4082 28.6498 43.9688C28.6498 43.5352 28.351 43.2715 27.894 43.2715H25.1108V41.0098H28.1811C28.6616 41.0098 28.9838 40.7344 28.9838 40.2773C28.9838 39.8203 28.6674 39.5449 28.1811 39.5449H24.226C23.6694 39.5449 23.3413 39.8848 23.3413 40.4648V47.1914C23.3413 47.7715 23.6694 48.1113 24.226 48.1113ZM32.8934 48.1113C33.4501 48.1113 33.7782 47.7715 33.7782 47.1914V41.0098H35.5302C36.0048 41.0098 36.327 40.7344 36.327 40.2773C36.327 39.8203 36.0106 39.5449 35.5302 39.5449H30.2626C29.7762 39.5449 29.4598 39.8203 29.4598 40.2773C29.4598 40.7344 29.7821 41.0098 30.2626 41.0098H32.0087V47.1914C32.0087 47.7715 32.3368 48.1113 32.8934 48.1113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi",
    x: 0.5,
    y: 0,
    width: 50,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.94444,
    dy: 1.85606
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.67803
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0275623 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 20.8634,
    y: 0.364843,
    width: 27.5408,
    height: 27.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64277,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.5,
    y1: 6,
    x2: 25.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337213,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.8792,
    y1: 9.54064,
    x2: 26.8948,
    y2: 16.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.b55f8c49e0914e73c81bde2f2c261d0b.svg";
export { ForwardRef as ReactComponent };